const IS_ACTIVE = 'is-active'
const IS_HIDDEN = 'is-hidden'

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.activeColor = null;
        this.slider = null;
        this.options = {};
        this.swiperWrapper = this.querySelector('swiper-main-product .swiper')

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false,
                ),
              );
          });

        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        )
        this.removeListSemantic();
      }

      connectedCallback() {
        if(this.swiperWrapper.dataset.desktopSlider === 'true') {
          this.initSlider()
        } else {
          this.manageSliderInstance();
          // Run on resize
          window.addEventListener('resize', this.manageSliderInstance.bind(this));
        }

        if (this.dataset.activeColor && this.dataset.activeColor !== 'default-title') {
          this.activeColor = this.dataset.activeColor;
          this.filterImagesByColor();

          this.addEventListener('colorChanged', (event) => {
            this.activeColor = event.detail.color;
            this.filterImagesByColor();
          });
        }

        // Listen for optimized gallery updates
        this.addEventListener('galleryUpdated', this.handleGalleryUpdate.bind(this));
      }

      manageSliderInstance() {
        const isMobile = window.innerWidth <= 768;

        if (isMobile && !this.slider) {
          this.initSlider()
        } else if (!isMobile && this.slider) {
          this.slider.destroy(true, true);
          this.slider = null;
        } else if (!isMobile && !this.slider) {
          // autoplay videos on desktop if no slider
          const videoSlides = this.swiperWrapper.querySelectorAll('.product__media-video');

          videoSlides.forEach((videoSlide) => {
            this.playActiveMedia(videoSlide);
          });
        }
      }

      initSlider() {
        this.options = {
          slidesPerView: 1.3,
          spaceBetween: 3,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
              spaceBetween: 0
            },
          },
        };

        this.slider = new Swiper(
          this.swiperWrapper,
          this.options,
        );

        const thisComponent = this;
        this.slider?.on('slideChange', function () {
          setTimeout(function() {
            thisComponent.onSlideChanged();
          }, 500);
        });
      }

      goToSlide(idx) {
        this.slider.slideTo(idx)
      }

      filterImagesByColor() {
        if (!this.activeColor || !this.dataset.hasVariantImages) {
          this.elements.viewer
            .querySelectorAll('[data-media-id]')
            .forEach((element) => {
              element.classList.remove(IS_HIDDEN);
            });


          this.elements.thumbnails && this.elements.thumbnails
            .querySelectorAll('[data-media-position]')
            .forEach((element) => {
              element.classList.remove(IS_HIDDEN);
            });
        } else {
          this.processElements.call(this, this.elements.viewer, 'li[data-media-id]');

          if (this.elements.thumbnails) {
            this.processElements.call(this, this.elements.thumbnails, '[data-media-position]');

            const firstImages = document.querySelector('.thumbnail-list__item:not(.is-hidden)');
            if (firstImages) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${firstImages.dataset.target}"]`);
              this.setActiveThumbnail(activeThumbnail);
            }
          }
        }
        this.updatePagination();
      }

      processElements(container, selector) {
        container.querySelectorAll(selector).forEach((element) => {
          const { classList, dataset } = element;
          dataset.color === this.activeColor
            ? classList.remove(IS_HIDDEN)
            : classList.add(IS_HIDDEN) && classList.remove(IS_ACTIVE);
        });
      }

      onSlideChanged() {
        const mediaId = this.elements.viewer.querySelector('.swiper-slide-active').dataset.mediaId

        // set active thumbnail if exists
        if(this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`,
          );
          this.setActiveThumbnail(thumbnail);
        }

        const activeMedia = this.elements.viewer.querySelector(
          `.swiper-slide-active[data-media-id="${mediaId}"]`,
        );

        this.playActiveMedia(activeMedia);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`,
        );

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove(IS_ACTIVE);
          });
        activeMedia.classList.add(IS_ACTIVE);

        this.goToSlide(Number(activeMedia.dataset.swiperSlideIndex))

        this.preventStickyHeader();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition,
        );
      }

      updatePagination() {
        const totalImages = this.elements.viewer.querySelectorAll('li[data-media-id]:not(.is-hidden)')
        if (totalImages.length <= 0) return;
        document.querySelectorAll('.slider-counter--total').forEach((element) => {
          element.textContent = totalImages.length;
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img',
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position,
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        // Trigger deferred-media to load video content
        this.querySelectorAll('deferred-media').forEach((deferredMedia) => {
          // deferredMedia.loadContent(false, true) // false to stop focus, true to prevent autoplay
        })
        // Pause all media
        window.pauseAllMedia();
        // Trigger video to play if the media slide contains a video
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          const video = deferredMedia.querySelector('video')
          if(video) {
            video.currentTime = 0
            video.play()
          } else {
            setTimeout(() => {
              deferredMedia.querySelector('button.deferred-media__poster').click();
            }, 500)
          }
          let videoHandlerButton = deferredMedia?.closest('.product-media-container').querySelector('.product-media__icons')
          videoHandlerButton?.setAttribute('data-video-state', 'playing')
        };
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer) return;
        this.elements.viewer.setAttribute('role', 'presentation');
      }

      handleGalleryUpdate(event) {
        const variant = event.detail.variant;
        
        // Update gallery data attributes first
        this.updateGalleryDataAttributes(variant);
        
        // Update active color if available
        if (variant && variant.featured_media) {
          // Update active color based on variant
          const newActiveColor = this.getActiveColorFromVariant(variant);
          if (newActiveColor && newActiveColor !== this.activeColor) {
            this.activeColor = newActiveColor;
            this.filterImagesByColor();
          }
        }

        // Refresh swiper if it exists
        if (this.slider) {
          // Update swiper with new content
          this.slider.update();
          
          // Ensure proper slide positioning
          if (this.slider.slides.length > 0) {
            // Go to first slide or maintain current position if valid
            const currentIndex = this.slider.activeIndex;
            const targetIndex = currentIndex < this.slider.slides.length ? currentIndex : 0;
            this.slider.slideTo(targetIndex, 0);
          }
          
          // Update pagination
          if (this.slider.pagination && this.slider.pagination.el) {
            this.slider.pagination.update();
          }
        }

        // Re-initialize event listeners for new slides
        this.reinitializeSlideEvents();
      }

      updateGalleryDataAttributes(variant) {
        // Update gallery data attributes based on the new variant
        if (variant && variant.featured_media) {
          // Update active color data attribute
          const newActiveColor = this.getActiveColorFromVariant(variant);
          if (newActiveColor) {
            this.dataset.activeColor = newActiveColor;
          }
          
          // Update total media count if needed
          const mediaCount = this.querySelectorAll('swiper-main-product .swiper-slide').length;
          this.dataset.totalMediaCount = mediaCount;
        }
      }

      getActiveColorFromVariant(variant) {
        // Extract color from variant options
        if (variant.options && variant.options.length > 0) {
          // Look for color option (this might need adjustment based on your variant structure)
          for (const option of variant.options) {
            if (option && option.toLowerCase().includes('color')) {
              return option.toLowerCase().replace(/\s+/g, '-');
            }
          }
        }
        return null;
      }

      reinitializeSlideEvents() {
        // Re-initialize any slide-specific event listeners
        const videoSlides = this.swiperWrapper.querySelectorAll('.product__media-video');
        videoSlides.forEach((videoSlide) => {
          this.playActiveMedia(videoSlide);
        });

        // Re-initialize thumbnail events if they exist
        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector('button');
              if (button) {
                // Remove existing listeners to prevent duplicates
                button.removeEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
                // Add new listener
                button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
              }
            });
        }
      }
    },
  );
}